import { render, staticRenderFns } from "./breadcrumb-pages.vue?vue&type=template&id=d753263e&"
import script from "./breadcrumb-pages.vue?vue&type=script&lang=js&"
export * from "./breadcrumb-pages.vue?vue&type=script&lang=js&"
import style0 from "./breadcrumb-pages.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports